<template>
  <nav class="social-icon-links" :aria-label="ariaLabel">
    <component
      :is="link.href ? 'a' : 'span'"
      v-for="link in links"
      :key="link.id"
      :href="link.href"
      class="social-icon-links__item social-icon-links__item--footer"
      :class="{ 'social-icon-links__item--pending': !link.href }"
      :target="link.href ? '_blank' : undefined"
      :rel="link.href ? 'noopener noreferrer' : undefined"
      :aria-label="link.label"
      :title="link.href ? link.label : `${link.label} (${pendingLabel})`"
      :aria-disabled="link.href ? undefined : 'true'"
    >
      <span class="social-icon-links__mark" aria-hidden="true">
        <GcsaIcon v-if="link.id === 'x'" name="x" />
        <GcsaIcon v-else-if="link.id === 'telegram'" name="telegram" />
        <GcsaIcon v-else name="arrow-right" />
      </span>
      <span class="social-icon-links__label">{{ link.label }}</span>
    </component>
  </nav>
</template>

<script setup lang="ts">
import GcsaIcon from './GcsaIcon.vue';

export type SiteFooterSocialLink = {
  id: string;
  label: string;
  href?: string;
  /** @deprecated 已内联 SVG，可忽略 */
  icon?: string;
};

withDefaults(
  defineProps<{
    links: SiteFooterSocialLink[];
    ariaLabel?: string;
    pendingLabel?: string;
  }>(),
  {
    ariaLabel: '社交媒体',
    pendingLabel: '即将开放'
  }
);
</script>
